import React from "react";
import "./pricingHeader.css";

const PricingHeader = ({ title, subTitle, step1, step2, step3, isLine1Active, isLine2Active }) => {

  return (
      <div className="choosePlan-heading">
        {title !== "" && (<h1>{title}</h1>)}
        <div className="choosePlan-header-img">
          <img src={step1} alt="Choose Plan" />
          <div className={`choosePlan-lines ${isLine1Active ? "active-line" : ""}`}>
            <div className="line line-1"></div>
          </div>
          <img src={step2} alt="Register" />
          <div className={`choosePlan-lines ${isLine2Active ? "active-line" : ""}`}>
            <div className="line line-2"></div>
          </div>
          <img src={step3} alt="Pay" />
        </div>
        {subTitle !== "" && (<h4>{subTitle}</h4>)}
      </div>
  );
};

export default PricingHeader;
